var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" btn btn-outline btn-lazy-load"},[_vm._v(" "+_vm._s(_vm.$t( 'shared.btn.lazyLoad', [ _vm.counter ] ))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }